module.exports = __webpack_public_path__ + "img/right03.ca1708cd.webp";